import modular from 'modujs';
import * as modules from './modules';
import globals from './globals';
import { debounce } from './utils/tickers';
import { $html } from './utils/dom';
import { ENV, FONT, CUSTOM_EVENT, CSS_CLASS } from './config'
import { isFontLoadingAPIAvailable, loadFonts } from './utils/fonts';
import CookieConsentManager from './cookies';

const app = new modular({
    modules
});

async function init() {
    bindEvents();
    globals();
    setViewportSizes();

    new CookieConsentManager().run(
        window.cookieConsentConfig,
        window.cookieConsentGtagMap
    )

    app.init(app)

    $html.classList.add(CSS_CLASS.LOADED, CSS_CLASS.FIRST_LOADED);
    $html.classList.remove(CSS_CLASS.LOADING);

    setTimeout(() => {
        $html.classList.add(CSS_CLASS.READY);
    }, 300);

    /**
   * Debug focus
   */
    // document.addEventListener(
    //     "focusin",
    //     function () {
    //         console.log('focused: ', document.activeElement)
    //     }, true
    // );

    /**
     * Eagerly load the following fonts.
     */
    if (isFontLoadingAPIAvailable) {
        loadFonts(FONT.EAGER, ENV.IS_DEV).then((eagerFonts) => {
            $html.classList.add(CSS_CLASS.FONTS_LOADED);

            /**
             * Debug fonts loading
             */
            if (ENV.IS_DEV) {
                console.group('Eager fonts loaded!', eagerFonts.length, '/', document.fonts.size);
                console.group('State of eager fonts:');
                eagerFonts.forEach(font => console.log(font.family, font.style, font.weight, font.status));
                console.groupEnd();
                console.group('State of all fonts:');
                document.fonts.forEach(font => console.log(font.family, font.style, font.weight, font.status));
                console.groupEnd();
            }
        });
    }
}

////////////////
// Global events
////////////////
function bindEvents() {
    // Resize event
    const resizeEndEvent = new CustomEvent(CUSTOM_EVENT.RESIZE_END)
    window.addEventListener(
        "resize",
        debounce(() => {
            window.dispatchEvent(resizeEndEvent)
        }, 200, false)
    )


    // Resize event
    const resizeEvent = new CustomEvent(CUSTOM_EVENT.RESIZE)
    window.addEventListener(
        "resize",
        () => {
            onResize()
            window.dispatchEvent(resizeEvent)
        }
    )
}

function onResize() {
    setViewportSizes()
}

function setViewportSizes() {

    // Document styles
    const documentStyles = document.documentElement.style;

    // Viewport width
    const vw = document.body.clientWidth * 0.01;
    documentStyles.setProperty('--vw', `${vw}px`);

    // Return if browser supports vh, svh, dvh, & lvh
    if (ENV.SUPPORTS_VH) {
        return
    }

    // Viewport height
    const svh = document.documentElement.clientHeight * 0.01;
    documentStyles.setProperty('--svh', `${svh}px`);

    const dvh = window.innerHeight * 0.01;
    documentStyles.setProperty('--dvh', `${dvh}px`);
}

////////////////
// Execute
////////////////
window.addEventListener('load', () => {
    init();
});